// Central site data + conversion tracking helpers for DG Guinchos

export const LOGO = "/fotos/logo.png";
export const OWNER_PHOTO = "/fotos/proprietario.jpg";

export const PHONE_DISPLAY = "(11) 92206-3894";
export const PHONE_TEL = "+5511922063894";
export const WHATSAPP_NUMBER = "5511922063894";
export const WHATSAPP_MSG =
  "Olá, encontrei a DG Guinchos pelo site e preciso de atendimento. Minha localização é:";
export const INSTAGRAM_URL = "https://instagram.com/dgguinchos24hrs";
export const INSTAGRAM_HANDLE = "@dgguinchos24hrs";

export const ADDRESS = {
  street: "R. São José dos Campos, 460",
  district: "Vila Ruy Barbosa",
  city: "Jundiaí - SP",
  zip: "13219-110",
};
export const MAPS_QUERY = encodeURIComponent(
  "R. São José dos Campos, 460 - Vila Ruy Barbosa, Jundiaí - SP, 13219-110"
);
export const MAPS_EMBED = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`;
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`;

// GA4 / Google Ads / GTM measurement ids — leave empty until real ids are provided.
export const GA_MEASUREMENT_ID = "";
export const GADS_CONVERSION_ID = "";

// Single dataLayer push — GTM (GTM-TFC7KTTJ) is the single source of truth and
// forwards to Google Ads / GA via its own tags. Do NOT also call gtag('event', ...)
// here, otherwise the same event is pushed twice per click.
export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const waLink = (extra = "") => {
  const msg = extra ? `${WHATSAPP_MSG} ${extra}` : WHATSAPP_MSG;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

export const onWhatsApp = (source) => track("whatsapp_click", { source });
export const onCall = (source) => track("phone_click", { source });
export const onRoute = (source) => track("route_click", { source });

export const IMG = {
  hero: "/fotos/hero.jpg",
  emergency:
    "https://images.pexels.com/photos/4173093/pexels-photo-4173093.jpeg?auto=compress&cs=tinysrgb&w=1200",
  carros:
    "https://images.pexels.com/photos/17429097/pexels-photo-17429097.jpeg?auto=compress&cs=tinysrgb&w=1000",
  flatbed:
    "https://images.unsplash.com/photo-1764200458388-65c4b0c19a95?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  transporte:
    "https://images.pexels.com/photos/8931963/pexels-photo-8931963.jpeg?auto=compress&cs=tinysrgb&w=1000",
  motos:
    "/fotos/moto.jpg",
  night:
    "https://images.unsplash.com/photo-1610641018556-030e920d6999?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  driving:
    "https://images.unsplash.com/photo-1742069029207-0aacf8fa4401?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  whiteTruck:
    "https://images.unsplash.com/photo-1742069029212-60e03b0e938d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  about: "/fotos/citroen.jpg",
  realHero: "/fotos/hero.jpg",
  realVw: "/fotos/vw.jpg",
  realSpin: "/fotos/spin.jpg",
  realFiesta: "/fotos/fiesta.jpg",
  realCitroen: "/fotos/citroen.jpg",
  realSprinter: "/fotos/sprinter.jpg",
  realDuster: "/fotos/duster.jpg",
  realMaster: "/fotos/master.jpg",
  realBau: "/fotos/bau.jpg",
  realGol: "/fotos/gol.jpg",
  realNoiteFront: "/fotos/noite-front.jpg",
  realNoiteRua: "/fotos/noite-rua.jpg",
};

export const SERVICES = [
  {
    id: "carros",
    title: "Guincho para Carros",
    desc: "Remoção e transporte de veículos com segurança e responsabilidade.",
    img: IMG.realGol,
    alt: "Guincho DG Guinchos carregando carro em Jundiaí SP",
  },
  {
    id: "motos",
    title: "Guincho para Motos",
    desc: "Transporte adequado para motocicletas, com fixação segura.",
    img: IMG.motos,
    alt: "Motocicleta transportada com segurança sobre plataforma da DG Guinchos em Jundiaí",
  },
  {
    id: "reboque",
    title: "Reboque de Veículos",
    desc: "Atendimento para veículos que precisam ser removidos ou transportados.",
    img: IMG.realMaster,
    alt: "Reboque de utilitário sobre plataforma DG Guinchos Jundiaí",
  },
  {
    id: "transporte",
    title: "Transporte de Veículos",
    desc: "Transporte programado entre diferentes localidades da região.",
    img: IMG.realSprinter,
    alt: "Transporte de van executiva pela DG Guinchos entre cidades da região",
  },
  {
    id: "emergencial",
    title: "Atendimento Emergencial",
    desc: "Precisou de auxílio com seu veículo? Fale agora com nossa equipe.",
    img: IMG.realNoiteFront,
    alt: "Guincho da DG Guinchos em atendimento noturno em Jundiaí, disponível 24 horas",
  },
];

export const CITIES = [
  {
    id: "guincho-jundiai",
    name: "Jundiaí",
    text: "Base da DG Guinchos. Atendimento 24 horas em toda a cidade de Jundiaí, do Centro aos bairros e rodovias que cortam a região, para carros e motos.",
  },
  {
    id: "guincho-varzea-paulista",
    name: "Várzea Paulista",
    text: "Guincho e reboque em Várzea Paulista com deslocamento rápido a partir de Jundiaí. Remoção de veículos parados em vias urbanas e acessos à cidade.",
  },
  {
    id: "guincho-campo-limpo-paulista",
    name: "Campo Limpo Paulista",
    text: "Socorro para veículos em Campo Limpo Paulista. Transporte seguro de carros e motos, seja em emergência ou em transporte previamente agendado.",
  },
  {
    id: "guincho-itupeva",
    name: "Itupeva",
    text: "Atendimento de guincho em Itupeva e região, incluindo apoio em trechos de rodovia e áreas de acesso a condomínios e distritos industriais.",
  },
  {
    id: "guincho-louveira",
    name: "Louveira",
    text: "Reboque e transporte de veículos em Louveira. Contamos com equipe preparada para remover seu carro ou moto com cuidado até o destino informado.",
  },
  {
    id: "regiao-metropolitana",
    name: "Região Metropolitana",
    text: "Cobrimos a Região Metropolitana de Jundiaí, conectando as principais cidades do entorno com serviço de guincho disponível 24 horas por dia.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Entre em contato",
    desc: "Ligue ou envie uma mensagem pelo WhatsApp. Nossa equipe está disponível 24 horas.",
  },
  {
    n: "02",
    title: "Informe sua localização",
    desc: "Envie sua localização e as informações básicas sobre o veículo.",
  },
  {
    n: "03",
    title: "Solicite o atendimento",
    desc: "Nossa equipe orientará você sobre o atendimento e o transporte do veículo.",
  },
];

export const FAQS = [
  {
    q: "A DG Guinchos funciona 24 horas?",
    a: "Sim. O atendimento funciona 24 horas por dia, sete dias por semana.",
  },
  {
    q: "A DG Guinchos atende Jundiaí?",
    a: "Sim. Jundiaí é uma das principais regiões atendidas pela empresa.",
  },
  {
    q: "Quais cidades vocês atendem?",
    a: "Jundiaí, Várzea Paulista, Campo Limpo Paulista, Itupeva, Louveira e região.",
  },
  {
    q: "Vocês transportam carros?",
    a: "Sim. A empresa realiza remoção e transporte de veículos.",
  },
  {
    q: "Vocês transportam motos?",
    a: "Sim. Também atendemos motocicletas.",
  },
  {
    q: "Como solicitar um guincho?",
    a: "Entre em contato pelo telefone ou WhatsApp e informe sua localização e informações sobre o veículo.",
  },
  {
    q: "Qual o telefone da DG Guinchos?",
    a: "(11) 92206-3894.",
  },
  {
    q: "Como saber o valor do guincho?",
    a: "O cliente deverá entrar em contato e informar a localização, destino e situação do veículo para receber as informações do atendimento.",
  },
];

export const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Serviços", href: "#servicos" },
  { label: "Áreas Atendidas", href: "#areas" },
  { label: "Sobre Nós", href: "#sobre" },
  { label: "Avaliações", href: "#avaliacoes" },
  { label: "Dúvidas", href: "#duvidas" },
  { label: "Contato", href: "#contato" },
];
